module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"do_refund":"Вернуть","on_card":"На карту/счет","full":"Полный","partial":"Частичный"},"en":{"do_refund":"Refund","on_card":"Card/invoice","full":"Full","partial":"Partial"}}')
  delete Component.options._Ctor
}
